export const profile = {
  name: 'Devika Ajith',
  initials: 'DA',
  role: 'Software Developer · Telecom T&M',
  tagline: 'Building tools at the edge of 5G, 6G & AI.',
  location: 'Munich, Germany',
  about:
    "Hola! I'm Devika Ajith — a Technical University of Munich graduate currently working as a software developer at Rohde & Schwarz on telecom test & measurement equipment. I spend my time at the intersection of 5G/6G signal processing, software engineering, and applied AI — and I share what I learn through writing and video.",
  email: 'devikaajith.work@gmail.com',
  socials: {
    medium: 'https://medium.com/@devcult',
    youtube: 'https://www.youtube.com/@devika_ajith',
    linkedin: 'https://www.linkedin.com/in/devika-ajith/',
    github: '',
  },
};

export const mediumUsername = 'devcult';

export const focusAreas = [
  {
    title: '5G / 6G',
    icon: 'signal',
    text: 'Test & measurement, NR protocols, RF signal processing, and the road to 6G.',
  },
  {
    title: 'Software Engineering',
    icon: 'code',
    text: 'Production-grade tooling, automation, and developer experience for instrument software.',
  },
  {
    title: 'Applied AI',
    icon: 'ai',
    text: 'ML for spectrum analysis, anomaly detection, and intelligent telecom workflows.',
  },
  {
    title: 'Tinkering',
    icon: 'chip',
    text: 'Embedded experiments, side projects, and weekend builds that keep curiosity alive.',
  },
];

export const projects = [
  {
    title: 'Project name — replace me',
    description:
      'Short description of what you built, the problem it solves, and the tech you used. Keep it 1–2 sentences.',
    tags: ['5G', 'Python', 'DSP'],
    link: '',
    repo: '',
  },
  {
    title: 'Another hobby build',
    description:
      'Describe the project, what you learned, and link to a demo or repo. Edit this list in src/data.js.',
    tags: ['AI', 'PyTorch'],
    link: '',
    repo: '',
  },
  {
    title: 'Side experiment',
    description:
      'A weekend tinker — embedded, web, or anything in between. Replace with your own.',
    tags: ['Embedded', 'C++'],
    link: '',
    repo: '',
  },
];

export const skills = [
  'Python', 'C++', 'MATLAB', 'JavaScript', 'React',
  '5G NR', 'RF / DSP', 'PyTorch', 'Git', 'Linux',
];

export const experience = [
  {
    role: 'Software Developer',
    org: 'Rohde & Schwarz',
    period: 'Present',
    location: 'Munich, Germany',
    points: [
      'Develop software for telecom test & measurement equipment used across the 5G ecosystem.',
      'Work across signal processing, instrument control, and tooling for RF engineers.',
    ],
  },
  {
    role: 'M.Sc. — replace with your program',
    org: 'Technical University of Munich',
    period: 'Graduated',
    location: 'Munich, Germany',
    points: [
      'Edit this entry in src/data.js — add your specialization, thesis, and notable coursework.',
    ],
  },
];
